import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

import { ConfigService } from '../../../core/config/config.service';
import { AuthTokenService } from '../../../core/auth/auth-token.service';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    standalone: false
})
export class TopBarComponent {
  readonly productName = environment.application?.name ?? 'PDTF Risk';

  constructor(
    private oauth: OAuthService,
    private tokens: AuthTokenService,
    public config: ConfigService,
  ) {}

  get isAuthenticated(): boolean {
    return this.tokens.isAuthenticated;
  }

  get principalLabel(): string {
    return this.config.config.principal.subject || 'Anonymous';
  }

  isAdmin(): boolean {
    return this.config.hasRole('pdtf-risk:admin');
  }

  logout(): void {
    this.oauth.logOut();
  }
}
